export default __webpack_public_path__ + "static/media/game.18b90e06.gif";